import logoAustags from "@/assets/testimonial/logo-austags.webp";
import logoBuzzy from "@/assets/testimonial/logo-buzzy.webp";
import logoSpace from "@/assets/testimonial/logo-space.webp";
import logoBayc from "@/assets/testimonial/logo-bayc.webp";
import logoAaa from "@/assets/testimonial/logo-aaa.webp";
import logoAppvisors from "@/assets/testimonial/logo-appvisors.webp";

export const testimonials = [
  {
    quote:
      "Devolysis consistently exceeds expectations, delivering exceptional results on time. Their final website is highly professional.",
    author: "Muhammad Saeed",
    company: "AUS TAGS",
    logo: logoAustags,
  },
  {
    quote:
      "They have maintained excellent communication and offered top-notch expertise, earning a perfect 10/10 rating!",
    author: "S Amini",
    company: "BUZZY AGENTS",
    logo: logoBuzzy,
  },
  {
    quote:
      "Devolysis led by Abdullah provide courteous, competent, and readily available services. Highly Recommended.",
    author: "Ara Khan",
    company: "SPACE",
    logo: logoSpace,
  },
  {
    quote:
      "Devolysis Did An Excellent Job On Our Landing Page And Gave Us Exactly What We Needed In A Very Timely Manner. Made Good Revisions Were Needed And Were Patient With Us. Excellent Professional. 10/10",
    author: "George Trakl",
    company: "BAYC",
    logo: logoBayc,
  },
  {
    quote:
      "The developers are highly professional, understanding user needs, and consistently exceeding expectations. Best Experience.",
    author: "Fergus Lowrey",
    company: "A. A & ASSOCIATES",
    logo: logoAaa,
  },
  {
    quote:
      "Developed a fully functional responsive website, surpassing expectations in record time.",
    author: "Mubashir Nawaz",
    company: "APP VISORS",
    logo: logoAppvisors,
  },
];
